import Environment from "../utils/Environment";

export const tokens = [
    {
        currency: "TASK",
        currencySymbol: "TASK",
        currencyAddress: Environment?.task,
        decimal: 18,
        type: "token",
        imgSrc: "/assets/createtask/Tasktoken.png",
    },
    {
        currency: "ORC",
        currencySymbol: "ORC",
        currencyAddress: Environment?.ORC,
        decimal: 18,
        type: "token",
        imgSrc: "/assets/createtask/Orctoken.png",
    },
    {
        currency: "ETH",
        currencySymbol: "ETH",
        currencyAddress: Environment?.ETH,
        decimal: 18,
        type: "coin",
        imgSrc: "/assets/createtask/eth.svg",
    },
    {
        currency: "USDT",
        currencySymbol: "USDT",
        currencyAddress: Environment?.USDT,
        decimal: 6,
        type: "token",
        imgSrc: "/assets/createtask/usdtT.svg",
    },
    // {
    //     currency: "Tomi",
    //     currencySymbol: "Tomi",
    //     currencyAddress: Environment?.tomi,
    //     decimal: 18,
    //     type: "token",
    //     imgSrc: "/assets/createtask/tomi.svg",
    // },
    {
        currency: "USDC",
        currencySymbol: "USDC",
        currencyAddress: Environment?.USDC,
        decimal: 6,
        type: "token",
        imgSrc: "/assets/createtask/usdc.svg",
    },
    {
        currency: "LINK",
        currencySymbol: "LINK",
        currencyAddress: Environment?.link,
        decimal: 18,
        imgSrc: "/assets/createtask/link.svg",
    },
    {
        currency: "PEPE",
        currencySymbol: "PEPE",
        currencyAddress: Environment.pepe,
        decimal: 18,
        imgSrc: "/assets/createtask/pepe.svg",
    },
    {
        currency: "UNI",
        currencySymbol: "UNI",
        currencyAddress: Environment.unisape,
        decimal: 18,
        imgSrc: "/assets/createtask/uni.svg",
    },
    // {
    //     currency: "DOP",
    //     currencySymbol: "DOP",
    //     currencyAddress: Environment?.dop,
    //     decimal: 18,
    //     imgSrc: "/assets/createtask/dop1.svg",
    //     type: "token",
    // },
    {
        currency: "WBTC",
        currencySymbol: "WBTC",
        decimal: 8,
        currencyAddress: Environment.wbtc,
        imgSrc: "/assets/createtask/wbtc.svg",
        type: "token",
    },
]